export const queryKeys = {
  me: ['me'] as const,
  store: ['store', 'me'] as const,
  products: (params?: unknown) => ['products', params ?? {}] as const,
  product: (id: string) => ['product', id] as const,
  importJob: (jobId: string) => ['import-job', jobId] as const,
  conversations: (params?: unknown) => ['conversations', params ?? {}] as const,
  conversation: (id: string) => ['conversation', id] as const,
  contacts: (params?: unknown) => ['contacts', params ?? {}] as const,
  contact: (id: string) => ['contact', id] as const,
  orders: (params?: unknown) => ['orders', params ?? {}] as const,
  order: (id: string) => ['order', id] as const,
  staff: ['staff'] as const,
  availability: (staffId?: string) =>
    (staffId ? (['availability', staffId] as const) : (['availability'] as const)),
  availabilitySlots: (params?: unknown) => ['availability', 'slots', params ?? {}] as const,
  bookings: (params?: unknown) => ['bookings', params ?? {}] as const,
  wallet: ['wallet'] as const,
  payouts: ['wallet', 'payouts'] as const,
  payoutAccount: ['payout-account'] as const,
  analyticsSummary: ['analytics', 'summary'] as const,
  analyticsGaps: ['analytics', 'gaps'] as const,
  notifications: (params?: unknown) => ['notifications', params ?? {}] as const,
  notificationsUnread: ['notifications', 'unread-count'] as const,
  notificationPrefs: ['notifications', 'preferences'] as const,
  pushPublicKey: ['notifications', 'push', 'public-key'] as const,
  whatsappChannel: ['channels', 'whatsapp'] as const,
  whatsappQr: ['channels', 'whatsapp', 'qr'] as const,
};
